module.exports = __webpack_public_path__ + "static/media/EnterpriseAppsMaker.e9921bf9.png";